import { Component, ElementRef } from "@angular/core";
import { Broadcaster } from "../service/Broadcaster";
import { SingService } from "../service/sing.service";
import {  saveFileCSV } from "../service/file-download-helper";
import { updateCategories } from "../class/broadcaster/update-categories";
import { ExportCsvService } from "./services/export-csv.service";
import { Alert } from "../class/alert/alert";
import { ExportCategory } from "../class/category/export-category";
import { Rooftop } from "../class/rooftop";
import { updateRooftops } from "../class/broadcaster/update-rooftops";
import { getSelectedRofftop } from "../class/broadcaster/app/get-selected-rofftop";
import { ExportRooftop } from "../class/export-rooftop";

@Component({
    selector: "export-csv-comp",
    templateUrl: "html/export-csv.component.html",
    styleUrls: ["css/export-csv.component.css"],
    providers: [SingService,ExportCsvService]
})
export class ExportCsvComponent {
    categorys:Array<ExportCategory> = [];
    rooftops:Array<ExportRooftop> = [];
    constructor(private broadcaster: Broadcaster, private elRef: ElementRef,private action:ExportCsvService ) { }
    ngOnInit() {
        this.action.onInit();
        this.broadcaster.on<any>("showExportCSV").subscribe(data => {
            if (data !== null)
            {
              this.closed();
            }
            else
            {
                this.action.show();
            }
          
         });
      
         this.broadcaster.on<any>("getSelectedRofftop").subscribe((data:getSelectedRofftop) => {
            this.rooftops = [];
             for (let i=0;i<data.rooftops.length;i++)
             {
                this.rooftops.push(new ExportRooftop(data.rooftops[i]));
             }
           
            
 
         });
        
         this.broadcaster.on<any>("updateRooftops").subscribe((data:updateRooftops) => {
            this.rooftops = [];
            for (let i=0;i<data.rooftops.length;i++)
            {
               this.rooftops.push(new ExportRooftop(data.rooftops[i]));
            }
            if (this.rooftops.length === 1)
            {
                this.rooftops[0].checked = true;
            }
        
         });
        this.broadcaster.on<any>("updateCategories").subscribe((data:updateCategories) => {
           this.getCategoryes(data);
        });
        
       
        this.elRef.nativeElement.querySelector(".export-csv-fon-closed").addEventListener(
            "click",
            (event) => {
                this.closed();
            },false);
        this.elRef.nativeElement.querySelector("#download-csv").addEventListener(
            "click",
            (event) => {
                if (this.action.countCategories === 0) {
                    this.broadcaster.broadcast("showAlert", new Alert(this.action.ErrorBudgetFile,true));
                    return;
                }
              
              this.elRef.nativeElement.querySelector("#preloader").style.display = "block";
              this.elRef.nativeElement.querySelector(".preloader-mask").style.display = "block";
              let dealerships:String = "";
              for (let i=0;i<this.rooftops.length;i++)
              {
                if (this.rooftops[i].checked)
                {
                    dealerships += `&dealerships[]=${this.rooftops[i].id}`;
                }
              }
                this.action
                    .getXLSBudget(dealerships)
                    .subscribe(data => {
                      
                        let index: number = this.action.rooftops.findIndex(item => item.class === "m--active");
                        let name = (this.action.rooftops.length === 1) ? this.action.rooftops[0].title : this.action.rooftops[index].title;
                        name = name.toLowerCase();
                        name = name.split(" ").join("-");
                      
       
                        saveFileCSV(data, `${name}-${this.action.tableData.settings.year}-${this.action.tableData.settings.month}`);
                        this.elRef.nativeElement.querySelector("#preloader").style.display = "none";
                        this.elRef.nativeElement.querySelector(".preloader-mask").style.display = "none";
                    },()=>{
                        this.elRef.nativeElement.querySelector("#preloader").style.display = "none";
                        this.elRef.nativeElement.querySelector(".preloader-mask").style.display = "none";
                    });
            }, false);
        
    }
    getCategoryes(data:any)
    {
        this.action.countCategories = data.categories.length;
        this.categorys = [];
      
        for (let i = 0; i < this.action.mediaCategories.length; i++) {
            for (let u = 0; u < data.categories.length; u++) {
                if (this.action.mediaCategories[i] === String(data.categories[u].id).split("categories-").join("")) {
                    this.categorys.push(new ExportCategory({ id: this.action.mediaCategories[i], title: data.categories[u].title, checked: true }));
                }
            }

        }
        
    }
    closed()
    {
      this.action.closed();
        this.categorys.map((item)=>{
            item.checked = true;
            return item;
        });
      
    }
   
}


// WEBPACK FOOTER //
// ./src/app/components/export-csv/export-csv.component.ts